// extracted by mini-css-extract-plugin
export default {"buttonCancel":"ButtonCancelLogout_buttonCancel__FrLUI"};